import clsx from "clsx";
import toast from "react-hot-toast";
import { IoClose, IoCheckmark, IoInformation } from "react-icons/io5";
import css from "./ToastCard.module.css";

const ICONS = {
  error: IoClose,
  success: IoCheckmark,
  info: IoInformation,
};

const ToastCard = ({
  t,
  title,
  description,
  type = "default",
  actions,
  onClose,
}) => {
  const kind = type === "default" ? "info" : type;
  const Icon = ICONS[kind];

  return (
    <div
      className={clsx(css.card, css[kind], t.visible ? css.enter : css.leave)}
      role={kind === "error" ? "alert" : "status"}
    >
      <span className={css.iconWrap}>
        <Icon className={css.icon} />
      </span>

      <div className={css.text}>
        <p className={clsx(css.title, description && css.titleWithDesc)}>
          {title}
        </p>
        {description && <p className={css.description}>{description}</p>}

        {/* actions: [{ label, onClick, variant: "accent" | "primary" | "secondary" }] — кнопки під текстом, після кліку сповіщення закривається */}
        {actions?.length > 0 && (
          <div className={css.actions}>
            {actions.map(({ label, onClick, variant = "accent" }) => (
              <button
                key={label}
                type="button"
                className={clsx(css.actionBtn, css[variant])}
                onClick={() => {
                  onClick?.();
                  toast.dismiss(t.id);
                }}
              >
                {label}
              </button>
            ))}
          </div>
        )}
      </div>

      <button
        type="button"
        className={css.closeBtn}
        onClick={() => {
          onClose?.();
          toast.dismiss(t.id);
        }}
        aria-label="Закрити сповіщення"
      >
        <IoClose />
      </button>
    </div>
  );
};

export default ToastCard;
